import React from 'react';
import './app.sass';
import MapApp from './_js/MapApp';
import { UserPreferencesProvider } from './_js/_UserPreferencesContext';
import { NavigationProvider } from './_js/_NavigationContext';
import { LangProvider } from './_js/_LangContext';
import { MapProvider } from './_js/_MapContext';
import { TabStateProvider } from './_js/_TabStateContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

//export const APP_VERSION = '1.2.1.250319.1';
export const APP_VERSION = '1.4.0.251224.1';

function AppRoutes()
{
    return (
        <>
            <Routes>
                <Route path="/" element={<MapApp />} />
                <Route path="/home" element={<MapApp />} />
                <Route path="/menu" element={<MapApp />} />
                <Route path="/building/:id" element={<MapApp />} />
                <Route path="/exterior/:id" element={<MapApp />} />
                <Route path="/restaurant/:id" element={<MapApp />} />
                <Route path="/stampcard" element={<MapApp />} />
            </Routes>
        </>
    );
}

function App()
{
    console.log(`[Tatemonoen Map ver:${APP_VERSION} date: ${new Date().toISOString().slice(0, 10)}]`);

    return (
        <Router basename="/map">
            <TabStateProvider>
                <UserPreferencesProvider>
                    <NavigationProvider>
                        <LangProvider>
                            <MapProvider>
                                <AppRoutes />
                            </MapProvider>
                        </LangProvider>
                    </NavigationProvider>
                </UserPreferencesProvider>
            </TabStateProvider>
        </Router>
    );
}

export default App;